import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.scss']
})

export class CaptchaComponent implements OnInit {


    public theme: 'light' | 'dark' = 'light';
    public size: 'compact' | 'normal' = 'normal';
    public lang = 'es';
    public type: 'image' | 'audio' = 'image';

    public aFormGroup: FormGroup;
    public siteKey = environment.siteKey;

    @Input()
    formGroup: FormGroup;

    @Input()
    element: any;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
      this.aFormGroup = this.formBuilder.group({
        recaptcha: ['', Validators.required]
      });
      console.log('el formulario y el elemento son ', this.formGroup, this.element);
    }

    handleSuccess(data): void {
        console.log('completado captcha', data);
        this.formGroup.get(this.element.name).setValue(data);
    }

    handleReset(): void {
      console.log('reset captcha');
      this.formGroup.get(this.element.name).setValue('');
    }

    handleExpire(): void {
      console.log('expire captcha');
      this.formGroup.get(this.element.name).setValue('');
    }

    handleError(): void {
      console.log('error captcha');
      this.formGroup.get(this.element.name).setValue('');
    }

    handleLoad(): void {
      console.log('load captcha');
    }

}
